import React from "react";
import { graphql } from "gatsby";
import { ArboretumMap } from "./ArboretumMap";
import { useTrees } from "../../../lib/useTrees";
import { KontentComponentSettings, StringValue } from "../../../types";
import { getMultiChoice } from "../../../lib/multichoice";

interface Props extends KontentComponentSettings {
  title: StringValue;
  tree_collection: {
    value: {
      codename: string;
      value: string;
    }[];
  };
}

const ArboretumMapContainer: React.FC<Props> = ({
  tree_collection,
  component_settings__hide_on_mobile,
  component_settings__anchor_name,
  title,
  ...props
}) => {
  const treesData = useTrees();

  const selectedCollections = tree_collection?.value;

  const trees =
    !selectedCollections || selectedCollections.length === 0
      ? treesData.trees
      : selectedCollections.flatMap(
          (collection) => treesData.collections[collection.codename]?.trees
        );

  if (!trees) return null;

  return (
    <ArboretumMap
      title={title?.value}
      anchor={component_settings__anchor_name?.value}
      hideOnMobile={
        getMultiChoice(component_settings__hide_on_mobile) === "yes"
      }
      trees={trees}
      {...props}
    ></ArboretumMap>
  );
};

export default ArboretumMapContainer;

export const fragmentArboretumMapContainer = graphql`
  fragment ArboretumMap on kontent_item_component___arboretum_map {
    system {
      id
      codename
    }
    internal {
      type
    }
    elements {
      title {
        value
      }
      tree_collection {
        value {
          codename
        }
      }
      component_settings__hide_on_mobile {
        value {
          codename
        }
      }
      component_settings__anchor_name {
        value
      }
    }
  }
`;
